/* eslint-disable @next/next/no-img-element */
import React, { Component } from 'react';
import classNames from 'classnames';

import styles from './Gallery.module.scss';
import { withTranslation, WithTranslation } from 'next-i18next';
import Button from '@/components/core/Button/Button';
import { IPressResource } from '@/interfaces/IPressResource';

interface IGalleryProps extends WithTranslation {
	className: string;
	collection: Array<IPressResource>;
	loading: boolean;
	onLoadMore: () => void;
	hasMore: boolean;
}

class Gallery extends Component<IGalleryProps> {
	items(collection: Array<IPressResource>) {
		return collection.map(({ url, id, description, image }) => {
			const href = url || image?.large?.url;

			return (
				<a href={href} target={'_blank'} className={styles.galleryItem} key={id}>
					<img src={image?.small?.url} alt={description} className={styles.galleryItemResourceImage} />
					{description ? <div className={styles.galleryItemDescription}>{description}</div> : null}
				</a>
			);
		});
	}

	render() {
		const { className, collection, loading, onLoadMore, hasMore, t } = this.props;

		const galeryClassNames = classNames(styles.gallery, className);

		return (
			<div className={galeryClassNames}>
				{collection ? (
					<div className={styles.galleryList}>{this.items(collection)}</div>
				) : (
					<div className={styles.galleryPreloader}>
						<div className={styles.galleryPreloaderSpinner} />
					</div>
				)}
				{hasMore ? (
					<Button
						className={styles.galleryLoadMore}
						color={Button.color.PRIMARY}
						loading={loading}
						onClick={onLoadMore}
					>
						{t('load-more')}
					</Button>
				) : null}
			</div>
		);
	}
}

export default withTranslation()(Gallery);
